import { ExclamationTriangleIcon, UserIcon } from "@heroicons/react/20/solid";
import React from "react";
import BuddyFace from "./images/buddy-face.png";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					className="block text-center bg-white"
					style={{ paddingTop: 120 }}
				>
					<div id="all-done">
						<div
							className="item item-circle bg-primary"
							style={{ position: "relative", height: "12rem", width: "12rem" }}
						>
							<ExclamationTriangleIcon
								style={{
									position: "absolute",
									height: "10rem",
									color: "white",
									right: "1rem",
									top: "1rem",
								}}
							/>
						</div>
						<div className="main">
							<h1 className="font-w700 text-center">An error has occurred</h1>
							<h4 className="text-center">We are sorry, something went wrong.</h4>
							<p className="text-center">If this continues to happen, please contact support</p>
							<p className="text-center">
								<a
									className="btn btn-primary"
									onClick={() => window.location.reload()}
									href={window.location}
								>
									Refresh Page
								</a>
								<a
									className="btn btn-primary"
									style={{ marginLeft: 10 }}
									href={`${window.location.origin}`}
								>
									Go to Home
								</a>
							</p>
						</div>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
